module.exports = __webpack_public_path__ + "static/img/dev5.08e58d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/dev5.jpg
// module id = G09r
// module chunks = 1